import type { ReactElement } from 'react';
import { QuoteStepItem } from './quote-step-item';
import { QUOTE_STEPS } from './quote-steps';

/**
 * 견적문의 "How it works" — 상품 고르기부터 확정견적·주문까지 네 단계.
 * 넓은 화면은 가로 타임라인, 좁은 화면은 세로 타임라인이다.
 */
export const QuoteGuideSteps = (): ReactElement => (
  <section aria-labelledby="quote-steps-heading" className="flex flex-col gap-10 sm:gap-14">
    <header className="flex flex-col gap-4">
      <h2
        id="quote-steps-heading"
        className="text-[clamp(2rem,3.6vw,3.25rem)] leading-none font-bold tracking-[-0.03em]"
      >
        <span aria-hidden>How it works</span>
        <span className="sr-only">견적 진행 과정</span>
      </h2>
      <p className="text-[15px] text-muted-foreground sm:text-base">
        디자인을 저장하면 그 디자인으로 견적을 요청할 수 있어요. 네 단계로 진행됩니다.
      </p>
    </header>

    <ol className="grid lg:grid-cols-4">
      {QUOTE_STEPS.map((step, index) => (
        <QuoteStepItem
          key={step.title}
          step={step}
          order={index + 1}
          isLast={index === QUOTE_STEPS.length - 1}
        />
      ))}
    </ol>
  </section>
);
